<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FBMHD">Contents</h1>
<h2 class="TOC-FBMHD"><a href="#/c01">Whoopie</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c02">Tools and Equipment</a></h2>
<h2 class="TOC-FBMHD"><a href="#/c03">Whoopie Recipes</a></h2>
<p class="TOC-AHD"><a href="#/c04">Chocolate Whoopie</a></p>
<p class="TOC-AHD"><a href="#/c05">Vanilla Whoopie</a></p>
<p class="TOC-AHD"><a href="#/c06">Red Velvet Whoopie</a></p>
<p class="TOC-AHD"><span href="#/c07" title="Link target outside of Sample">Apple Pie Whoopie</span></p>
<p class="TOC-AHD"><span href="#/c08" title="Link target outside of Sample">Banana Whoopie</span></p>
<p class="TOC-AHD"><span href="#/c09" title="Link target outside of Sample">Coconut Whoopie</span></p>
<h2 class="TOC-FBMHD"><span href="#/c10" title="Link target outside of Sample">Fillings and Toppings</span></h2>
<p class="TOC-AHD"><span href="#/c10#Buttercream" title="Link target outside of Sample">Vanilla Buttercream Filling</span></p>
<p class="TOC-AHD"><span href="#/c10#Marshmallow-Cream-Filling" title="Link target outside of Sample">Marshmallow Cream Filling</span></p>
<p class="TOC-AHD"><span href="#/c10#cinn" title="Link target outside of Sample">Cinnamon Cream Cheese Filling</span></p>
<p class="TOC-AHD"><span href="#/c10#coco" title="Link target outside of Sample">Coconut and Lime Filling</span></p>
<p class="TOC-AHD"><span href="#/c10#cre" title="Link target outside of Sample">Creamy Maple Syrup Filling</span></p>
<p class="TOC-AHD"><span href="#/c10#pea" title="Link target outside of Sample">Peanut Butter Cream Filling</span></p>
<p class="TOC-AHD"><span href="#/c10#Chocolate-Ganache-Topping" title="Link target outside of Sample">Chocolate Ganache Topping</span></p>
<p class="TOC-AHD"><span href="#/c10#sug" title="Link target outside of Sample">Sugarpaste</span></p>
<p class="TOC-AHD"><span href="#/c10#pet" title="Link target outside of Sample">Petal Paste</span></p>
<p class="TOC-AHD"><span href="#/c10#Royal-Icing" title="Link target outside of Sample">Royal Icing</span></p>
<h2 class="TOC-FBMHD"><span href="#/c11" title="Link target outside of Sample">Techniques</span></h2>
<p class="TOC-AHD"><span href="#/c11#Rolling-Out-Sugarpaste" title="Link target outside of Sample">Rolling Out Sugarpaste and Petal Paste</span></p>
<p class="TOC-AHD"><span href="#/c11#Cutting-Out-Shapes" title="Link target outside of Sample">Cutting Out Shapes</span></p>
<p class="TOC-AHD"><span href="#/c11#fril" title="Link target outside of Sample">Frilling</span></p>
<p class="TOC-AHD"><span href="#/c11#Shaping-Flowers" title="Link target outside of Sample">Shaping Flowers</span></p>
<p class="TOC-AHD"><span href="#/c11#Piping" title="Link target outside of Sample">Piping</span></p>
<p class="TOC-AHD"><span href="#/c11#Painting-Faces" title="Link target outside of Sample">Painting Faces</span></p>
<p class="TOC-AHD"><span href="#/c11#Using-Wires" title="Link target outside of Sample">Using Wires</span></p>
<p class="TOC-AHD"><span href="#/c11#Making-Figures" title="Link target outside of Sample">Making Figures</span></p>
<p class="TOC-AHD"><span href="#/c11#Colouring" title="Link target outside of Sample">Colouring</span></p>
<h2 class="TOC-CH-T"><span href="#/c12" title="Link target outside of Sample">Pretty as a Picture</span></h2>
<h2 class="TOC-CH-T"><span href="#/c23" title="Link target outside of Sample">Sweet Celebrations</span></h2>
<h2 class="TOC-CH-T"><span href="#/c35" title="Link target outside of Sample">Love is in the Air</span></h2>
<h2 class="TOC-CH-T"><span href="#/c45" title="Link target outside of Sample">Child’s Play</span></h2>
<h2 class="TOC-FBMHD"><span href="#/supp" title="Link target outside of Sample">Suppliers</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ata" title="Link target outside of Sample">About the Authors</span></h2>
<h2 class="TOC-FBMHD"><span href="#/ack" title="Link target outside of Sample">Acknowledgments</span></h2>
<h2 class="TOC-FBMHD"><span href="#/cop" title="Link target outside of Sample">Copyright</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?32cbc092